import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import styled from 'styled-components'

import { CommentItemBody } from './comment-item-body'
import { CommentItemFooter } from './comment-item-footer'
import { CommentItemHeader } from './comment-item-header'
import { CommentItemReplies } from './comment-item-replies'

import type { CommentId } from '../../model/comment-id'
import type { Comment } from '@root/entities/comment'
import type { CommentsModel } from '@root/features/comment/atoms'

type CommentItemProps = {
  comment: Comment.Comment
  model: CommentsModel
}

export const CommentItem = ({ comment, model, ...props }: CommentItemProps) => {
  const [depth, setDepth] = useState<number | undefined>(undefined)
  const [highlightId, setHighlight] = useState<CommentId | undefined>(undefined)
  const [collapseId, setCollapse] = useState<CommentId | undefined>(undefined)

  const topCollapseHidden = depth !== -1 && comment.id === collapseId
  const repliesLoadedTotal = comment.replies.reduce(
    (acc, r) => acc + 1 + r.totalReplies,
    0,
  )

  const [threadMode] = useAtom(model.commentsThreadModeAtom)

  const hasMoreReplies =
    threadMode === 'dynamic' && repliesLoadedTotal < comment.totalReplies

  return (
    <Root {...props}>
      <CommentItemHeader comment={comment} model={model} />
      <CommentItemBody
        comment={comment}
        topCollapseHidden={topCollapseHidden}
        highlightId={highlightId}
        //actions
        setCollapse={setCollapse}
        setHighlight={setHighlight}
        setDepth={setDepth}
        model={model}
      />
      <CommentItemReplies
        hasMoreReplies={hasMoreReplies}
        comment={comment}
        collapseId={collapseId}
        highlightId={highlightId}
        depth={depth}
        //actions
        setCollapse={setCollapse}
        setHighlight={setHighlight}
        setDepth={setDepth}
        model={model}
      />
      <CommentItemFooter
        hasMoreReplies={hasMoreReplies}
        comment={comment}
        model={model}
        depth={depth}
        onExpandClick={() => {
          setDepth(undefined)
          setHighlight(undefined)
          setCollapse(undefined)
        }}
      />
    </Root>
  )
}

const Root = styled.article`
  display: grid;
  position: relative;
`
